import { createStyles, Theme } from '@material-ui/core'
import { transition } from '../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export type AppPaginationSpacing = 'section' | 'toolbar' | 'minimal'

export const useAppPaginationStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiPagination-ul': {
        gap: theme.spacing(0.5),
      },
      '& .MuiPaginationItem-root': {
        fontWeight: 600,
        borderRadius: theme.shape.borderRadius * 2,
        transition: transition,
        '&:hover': {
          backgroundColor: theme.palette.grey[100],
        },
      },
      '& .MuiPaginationItem-page.Mui-selected': {
        fontWeight: 700,
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        color: theme.palette.common.white,
        boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
        '&:hover': {
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        },
        '&.Mui-disabled': {
          boxShadow: 'none',
        },
      },
    },
    spacingSection: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(4, 0),
    },
    spacingToolbar: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    spacingMinimal: {
      display: 'inline-block',
      padding: '40px 0',
    },
  })
)
